// src/supabaseClient.ts
// Alias racine pour compatibilité avec les imports existants (ex: ../supabaseClient)
// Rend le build Linux/Render stable sans modifier les pages.

// 🚨 SYSTÈME DE SÉCURITÉ ANTI-PAGE BLANCHE
// Vérification stricte des variables d'environnement avant d'initialiser Supabase
const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  console.error(
    "🚨 ERREUR CRITIQUE VITE : Les variables VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY sont manquantes ou vides au moment de la compilation."
  );
  console.error("👉 SOLUTION : Sur Render, allez dans 'Manual Deploy' (en haut à droite) et cliquez OBLIGATOIREMENT sur 'Clear build cache & deploy'.");
} else {
  console.log("✅ Clés Supabase détectées avec succès par Vite.");
}

// On exporte ton client existant pour conserver 100% des fonctionnalités
export { supabase, SUPABASE_URL } from './services/supabaseClient';
export { default } from './services/supabaseClient';
